
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/faculdade",
      function () {
        return require("private-next-pages/projects/faculdade.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/faculdade"])
      });
    }
  